import { BaseSdk } from '../../base.sdk';
import { LinkedinPostDto } from '@andsend/services/linkedin-profiles/shared';
export class LinkedinPostsSdk extends BaseSdk {
    async getLinkedinPost(postId: string) {
        return await this.get<LinkedinPostDto>(`${this.linkedinPostsPath}/${postId}`);
    }

    async addLinkedinPost(posts: LinkedinPostDto[]) {
        return await this.post({
            path: `${this.linkedinPostsPath}`,
            payload: { posts },
        });
    }
}
